const rankings = [
  { rank: 1, title: '顶流男星深夜约会神秘女子', hot: 9999, tag: '新', change: 'up' },
  { rank: 2, title: '乘风破浪新一季嘉宾名单流出', hot: 8750, tag: '热', change: 'up' },
  { rank: 3, title: '某知名夫妻被曝已分居半年', hot: 7620, tag: '爆', change: 'up' },
  { rank: 4, title: '国产科幻大片预告片播放破2亿', hot: 6890, tag: '', change: 'down' },
  { rank: 5, title: '知名乐队主唱宣布单飞引热议', hot: 5980, tag: '热', change: 'up' },
  { rank: 6, title: 'LPL夏季赛总决赛门票秒罄', hot: 5120, tag: '', change: 'same' },
];

export default function RankingSection() {
  const getChangeIcon = (change: string) => {
    if (change === 'up') return <i className="ri-arrow-up-fill text-primary-500"></i>;
    if (change === 'down') return <i className="ri-arrow-down-fill text-foreground-400"></i>;
    return <i className="ri-subtract-line text-foreground-400"></i>;
  };

  return (
    <section
      id="ranking"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            大瓜热榜
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            实时热度排行，看看大家都在追什么瓜
          </p>
        </div>

        <div className="flex flex-col gap-1">
          {/* Header */}
          <div className="hidden md:flex items-center gap-3 px-4 py-2 text-xs text-foreground-500 font-medium border-b border-background-200/70">
            <span className="w-10 text-center">排名</span>
            <span className="flex-1">标题</span>
            <span className="w-24 text-right">热度</span>
            <span className="w-12 text-center">趋势</span>
          </div>

          {rankings.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 px-4 py-3 rounded-md hover:bg-background-100 transition-colors duration-150 border-b border-background-200/50 last:border-b-0"
            >
              {/* Rank */}
              <span
                className={`w-10 flex-shrink-0 text-center font-bold text-lg ${
                  item.rank <= 3 ? 'text-primary-500' : 'text-foreground-500'
                }`}
              >
                {item.rank <= 3 ? (
                  <span className="w-6 h-6 inline-flex items-center justify-center rounded bg-primary-100 text-primary-600 text-sm font-bold">
                    {item.rank}
                  </span>
                ) : (
                  item.rank
                )}
              </span>

              {/* Title + Tag */}
              <span className="flex-1 min-w-0 text-sm md:text-base text-foreground-800 font-medium truncate">
                {item.title}
              </span>

              {/* Tag */}
              {item.tag && (
                <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              )}

              {/* Hot */}
              <span className="hidden md:block w-24 text-right text-sm text-foreground-500 font-mono whitespace-nowrap">
                {item.hot.toLocaleString()}
              </span>

              {/* Change */}
              <span className="w-12 flex items-center justify-center text-sm">
                {getChangeIcon(item.change)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}